import React, { memo } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { FONTS } from '@bcm/constants';

import GlobalPressable from '../../UI/button/GlobalPressable';
import { bodySiteCanvasDims } from './bodySiteCanvasUtils';
import commonStyles from '../../UI/styles/common';

const BodySiteCanvasColorButton = ({
	dims,
	isSelected,
	color,
	textColor,
	onPress,
	displayText,
	tbsaData,
	code,
	isLandscape,
}) => {


	const width = dims.width / (isLandscape ? 3.3 : 2.8);
	const height = ((dims.height / bodySiteCanvasDims.buttonContainerScale) / 5) - 4;

	const styles = StyleSheet.create({
		container: {
			width: isSelected ? width + width * 0.1 : width,
			height: isSelected ? height + height * 0.1 : height,
			flexDirection: 'column',
			borderRadius: 5,
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: color,
			shadowOffset: isSelected ? { width: 0, height: 0 } : undefined,
			shadowRadius: isSelected ? 10 : undefined,
			shadowOpacity: isSelected ? .5 : undefined,
			shadowColor: isSelected ? color : undefined,
		},
		text: {
			marginHorizontal: 5,
			fontFamily: FONTS.default,
			color: textColor,
		},
		textTitle: {
			fontSize: height / (isLandscape ? 3 : 3.5)
		},
		textPercent: {
			fontSize: height / (isLandscape ? 2.5 : 3)
		},
	});

	return (
		<GlobalPressable
			style={styles.container}
			onPress={onPress}
		>
			<View style={commonStyles.containers.row}>
				<Text style={[styles.text, styles.textTitle]}>{displayText}</Text>
			</View>
			<View style={commonStyles.containers.row}>
				<Text style={[styles.text, styles.textPercent]}>
					{(tbsaData && tbsaData[code]) ?
						`${(tbsaData[code] * 100).toFixed(1)}%`
						: '0.0%'}
				</Text>
			</View>
		</GlobalPressable>
	);
};

export default memo(BodySiteCanvasColorButton);